import CitySEOHead from "@/components/feature/CitySEOHead";
import CedarKeyHeroSection from "./components/HeroSection";
import CedarKeyStickyNav from "./components/StickyNav";
import CedarKeyProcessingTimeSection from "./components/ProcessingTimeSection";
import CedarKeyServicesSection from "./components/ServicesSection";
import CedarKeyLocalAreaSection from "./components/LocalAreaSection";
import CedarKeyTestimonialsSection from "./components/TestimonialsSection";
import CedarKeyAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import CedarKeyComparisonSection from "./components/ComparisonSection";
import CedarKeyMistakesSection from "./components/MistakesSection";
import CedarKeyHowItWorksSection from "./components/HowItWorksSection";
import CedarKeyFAQSection, { faqs } from "./components/FAQSection";
import CedarKeyHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import CedarKeyFinalCTA from "./components/FinalCTA";

const pageTitle = "Emergency Passport Cedar Key, FL — Expedited & Fast Passport Service | Fast Passport Center";
const pageDescription = "Emergency and expedited passport services in Cedar Key, FL — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving the Florida Nature Coast, Big Bend, and Levy County.";

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function CedarKeyPage() {
  return (
    <>
      <CitySEOHead
        city="Cedar Key"
        state="Florida"
        stateAbbr="FL"
        route="/cedar-key"
        title={pageTitle}
        description={pageDescription}
        ogTitle={pageTitle}
        ogDescription={pageDescription}
        twitterTitle={pageTitle}
        twitterDescription={pageDescription}
        geoPlacename="Cedar Key, Florida"
        geoPosition="29.1386;-83.0418"
        keywords="expedited passport Cedar Key, emergency passport Cedar Key FL, same day passport Cedar Key, fast passport Florida, passport renewal Cedar Key, Levy County passport"
        faqs={faqs}
        servicesSchema={servicesList}
        statePageName="Florida"
        statePageRoute="/states/florida"
        lastModified="2026-06-09"
        serviceAreaDesc="Fast Passport Center does not have a physical office in Cedar Key — we serve this area remotely. Emergency and expedited passport services as fast as 24 hours."
      />

      <div className="font-sans">
      <CedarKeyHeroSection />
      <CedarKeyStickyNav />
      <CedarKeyProcessingTimeSection />
      <CedarKeyServicesSection />
      <CedarKeyLocalAreaSection />
      <CedarKeyTestimonialsSection />
      <CedarKeyAcceptanceFacilitiesSection />
      <CedarKeyComparisonSection />
      <CedarKeyMistakesSection />
      <CedarKeyHowItWorksSection />
      <CedarKeyFAQSection />
      <CedarKeyHelpfulResourcesSection />
      <CedarKeyFinalCTA />
      </div>
    </>
  );
}